angular.module('unica_feedback.feedback_services')

.factory('FeedbackDeleteService', function ($http, getBaseApiURL) {

	var feedbackDeleteService = {};

	feedbackDeleteService.delete = function (feedbackId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/feedback/delete/' + feedbackId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return feedbackDeleteService;
});